// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Api } from "../Api/Api";

// export default function StockCredit() {
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedProduct, setSelectedProduct] = useState("");
//   const [quantity, setQuantity] = useState(1);
//   const [workerName, setWorkerName] = useState("");
//   const [workerPhone, setWorkerPhone] = useState("");
//   const [workerAddress, setWorkerAddress] = useState("");
//   const [records, setRecords] = useState([]);
//   const [editRecordId, setEditRecordId] = useState(null);
//   const [editValue, setEditValue] = useState(0);

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(`${Api}product/read.php`);
//       setProducts(res.data);

//       const uniqueCats = [
//         ...new Set(res.data.map((p) => p.category).filter(Boolean)),
//       ];
//       setCategories(uniqueCats);
//     } catch (err) {
//       console.error("Fetch products error:", err);
//     }
//   };

//   const fetchCredits = async () => {
//     try {
//       const res = await axios.get(`${Api}stockcredit/stockcredit_read.php`);
//       const dataArray = Array.isArray(res.data)
//         ? res.data
//         : Object.values(res.data);
//       setRecords(dataArray);
//     } catch (err) {
//       console.error("Fetch credits error:", err);
//       setRecords([]);
//     }
//   };

//   useEffect(() => {
//     fetchProducts();
//     fetchCredits();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedCategory || !selectedProduct || !workerName || !workerPhone) {
//       alert("Please fill all required fields!");
//       return;
//     }

//     const product = products.find((p) => p.id === parseInt(selectedProduct));
//     if (!product) return;

//     if (quantity > product.stock) {
//       alert("Quantity cannot exceed available stock!");
//       return;
//     }

//     try {
//       await axios.post(`${Api}stockcredit/stockcredit_create.php`, {
//         product_id: product.id,
//         product: product.product,
//         category: selectedCategory,
//         quantity,
//         returned_qty: 0, // default
//         worker_name: workerName,
//         worker_phone: workerPhone,
//         worker_address: workerAddress,
//       });

//       await axios.put(
//         `${Api}product/update.php?id=${product.id}`,
//         { stock: product.stock - quantity },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       alert("Stock credited successfully!");
//       fetchProducts();
//       fetchCredits();

//       setSelectedCategory("");
//       setSelectedProduct("");
//       setQuantity(1);
//       setWorkerName("");
//       setWorkerPhone("");
//       setWorkerAddress("");
//     } catch (err) {
//       console.error("Submit error:", err);
//     }
//   };

//   const handleSaveReturn = async (record) => {
//     if (editValue < 0 || editValue > record.quantity) {
//       alert("Invalid returned quantity!");
//       return;
//     }

//     const diff = editValue - (record.returned_qty || 0);

//     try {
//       // update product stock
//       const product = products.find(
//         (p) => p.id === parseInt(record.product_id)
//       );
//       if (!product) {
//         alert("Product not found!");
//         return;
//       }

//       await axios.put(
//         `${Api}product/update.php?id=${product.id}`,
//         { stock: product.stock + diff },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       // update stockcredit record
//       const returnedFlag = editValue === record.quantity ? 1 : 0;
//       await axios.put(
//         `${Api}stockcredit/stockcredit_return.php?id=${record.id}`,
//         {
//           quantity: record.quantity,
//           returned_qty: editValue,
//           returned: returnedFlag,
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       // ✅ update local state instantly
//       setRecords((prev) =>
//         prev.map((rec) =>
//           rec.id === record.id
//             ? { ...rec, returned_qty: editValue, returned: returnedFlag }
//             : rec
//         )
//       );

//       alert("Return quantity updated!");
//       fetchProducts();
//       setEditRecordId(null);
//       setEditValue(0);
//     } catch (err) {
//       console.error("Save return error:", err);
//     }
//   };

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <div className="max-w-5xl mx-auto bg-white p-6 rounded shadow">
//         <h2 className="text-2xl font-semibold mb-4">Stock Credit</h2>

//         {/* Credit Form */}
//         <form
//           onSubmit={handleSubmit}
//           className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6"
//         >
//           <div>
//             <label className="block font-medium mb-1">Category</label>
//             <select
//               value={selectedCategory}
//               onChange={(e) => setSelectedCategory(e.target.value)}
//               className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
//             >
//               <option value="">Select Category</option>
//               {categories.map((cat, i) => (
//                 <option key={i} value={cat}>
//                   {cat}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div>
//             <label className="block font-medium mb-1">Product</label>
//             <select
//               value={selectedProduct}
//               onChange={(e) => setSelectedProduct(e.target.value)}
//               className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
//             >
//               <option value="">Select Product</option>
//               {products
//                 .filter((p) => p.category === selectedCategory)
//                 .map((p) => (
//                   <option key={p.id} value={p.id}>
//                     {p.product} (Stock: {p.stock})
//                   </option>
//                 ))}
//             </select>
//           </div>

//           <div>
//             <label className="block font-medium mb-1">Quantity</label>
//             <input
//               type="number"
//               min="1"
//               value={quantity}
//               max={
//                 selectedProduct
//                   ? products.find((p) => p.id === parseInt(selectedProduct))
//                       ?.stock
//                   : 1
//               }
//               onChange={(e) => setQuantity(Number(e.target.value))}
//               className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
//             />
//           </div>

//           <div>
//             <label className="block font-medium mb-1">Worker Name</label>
//             <input
//               type="text"
//               value={workerName}
//               onChange={(e) => setWorkerName(e.target.value)}
//               className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
//             />
//           </div>

//           <div>
//             <label className="block font-medium mb-1">Worker Phone</label>
//             <input
//               type="text"
//               value={workerPhone}
//               onChange={(e) => setWorkerPhone(e.target.value)}
//               className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
//             />
//           </div>

//           <div>
//             <label className="block font-medium mb-1">Worker Address</label>
//             <input
//               type="text"
//               value={workerAddress}
//               onChange={(e) => setWorkerAddress(e.target.value)}
//               className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
//             />
//           </div>

//           <div className="md:col-span-2">
//             <button
//               type="submit"
//               className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition w-full md:w-auto"
//             >
//               Submit
//             </button>
//           </div>
//         </form>

//         {/* Records Table */}
//         <h3 className="text-xl font-semibold mb-3">Stock Credit Records</h3>

//         <div className="overflow-x-auto">
//           <table className="min-w-full bg-white border rounded">
//             <thead className="bg-gray-100">
//               <tr>
//                 {[
//                   "ID",
//                   "Worker",
//                   "Phone",
//                   "Product",
//                   "Category",
//                   "Quantity",
//                   "Returned Quantity",
//                   "Balance",
//                   "Address",
//                   "Date",
//                   "Status / Action",
//                 ].map((head) => (
//                   <th key={head} className="text-left px-4 py-2 border">
//                     {head}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {Array.isArray(records) && records.length > 0 ? (
//                 records.map((r) => (
//                   <tr
//                     key={r.id}
//                     className={`${r.returned ? "bg-green-100" : ""}`}
//                   >
//                     <td className="px-4 py-2 border">{r.id}</td>
//                     <td className="px-4 py-2 border">{r.worker_name}</td>
//                     <td className="px-4 py-2 border">{r.worker_phone}</td>
//                     <td className="px-4 py-2 border">{r.product}</td>
//                     <td className="px-4 py-2 border">{r.category}</td>
//                     <td className="px-4 py-2 border">{r.quantity}</td>

//                     {/* Returned Quantity */}
//                     <td className="px-4 py-2 border">
//                       {editRecordId === r.id ? (
//                         <input
//                           type="number"
//                           min="0"
//                           max={r.quantity}
//                           value={editValue}
//                           onChange={(e) => setEditValue(Number(e.target.value))}
//                           className="w-20 border rounded px-2 py-1"
//                         />
//                       ) : (
//                         r.returned_qty
//                       )}
//                     </td>

//                     {/* Balance = quantity - returned_qty */}
//                     <td
//                       className={`px-4 py-2 border font-semibold ${
//                         r.quantity - (r.returned_qty || 0) > 0
//                           ? "text-red-600"
//                           : "text-green-600"
//                       }`}
//                     >
//                       {r.quantity - (r.returned_qty || 0)}
//                     </td>

//                     <td className="px-4 py-2 border">{r.worker_address}</td>
//                     <td className="px-4 py-2 border">{r.created_at}</td>

//                     <td className="px-4 py-2 border">
//                       {r.returned ? (
//                         <span className="text-green-600 font-semibold">
//                           Returned
//                         </span>
//                       ) : editRecordId === r.id ? (
//                         <div className="flex gap-2">
//                           <button
//                             onClick={() => handleSaveReturn(r)}
//                             className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
//                           >
//                             Save
//                           </button>
//                           <button
//                             onClick={() => {
//                               setEditRecordId(null);
//                               setEditValue(0);
//                             }}
//                             className="bg-gray-400 text-white px-3 py-1 rounded hover:bg-gray-500"
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       ) : (
//                         <button
//                           onClick={() => {
//                             setEditRecordId(r.id);
//                             setEditValue(r.returned_qty || 0);
//                           }}
//                           className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
//                         >
//                           Edit
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="11" className="text-center px-4 py-2 border">
//                     No records found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Api } from "../Api/Api";
import Swal from "sweetalert2";

export default function StockCredit() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [workerName, setWorkerName] = useState("");
  const [workerPhone, setWorkerPhone] = useState("");
  const [workerAddress, setWorkerAddress] = useState("");

  const [records, setRecords] = useState([]);
  const [editRecordId, setEditRecordId] = useState(null);
  const [editValue, setEditValue] = useState(0);

  // Fetch products
  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${Api}product/read.php`);
      setProducts(res.data);
      const uniqueCats = [
        ...new Set(res.data.map((p) => p.category).filter(Boolean)),
      ];
      setCategories(uniqueCats);
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch stock credit records
  const fetchCredits = async () => {
    try {
      const res = await axios.get(`${Api}stockcredit/stockcredit_read.php`);
      const dataArray = Array.isArray(res.data)
        ? res.data
        : Object.values(res.data);
      setRecords(dataArray);
    } catch (err) {
      console.error(err);
      setRecords([]);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchCredits();
  }, []);

  // Add product to local list before submit
  const handleAddProduct = () => {
    if (!selectedCategory || !selectedProduct || quantity <= 0) {
      alert("Please select a product and valid quantity");
      return;
    }

    const product = products.find((p) => p.id === parseInt(selectedProduct));
    if (!product) return;

    if (quantity > product.stock) {
      alert("Quantity cannot exceed available stock!");
      return;
    }

    const exists = selectedProducts.find((p) => p.id === product.id);
    if (exists) {
      setSelectedProducts((prev) =>
        prev.map((p) =>
          p.id === product.id ? { ...p, quantity: p.quantity + quantity } : p
        )
      );
    } else {
      setSelectedProducts((prev) => [
        ...prev,
        {
          id: product.id,
          product: product.product,
          category: product.category,
          quantity,
        },
      ]);
    }

    setSelectedCategory("");
    setSelectedProduct("");
    setQuantity(1);
  };

  // Submit all products + worker info
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!workerName || !workerPhone || selectedProducts.length === 0) {
      alert("Please fill worker info and add at least one product!");
      return;
    }

    try {
      await axios.post(`${Api}stockcredit/stockcredit_create.php`, {
        worker_name: workerName,
        worker_phone: workerPhone,
        worker_address: workerAddress,
        products: selectedProducts.map((sp) => ({
          product_id: sp.id,
          product: sp.product,
          category: sp.category,
          quantity: sp.quantity,
        })),
      });

      // reduce stock for each product
      for (let sp of selectedProducts) {
        const product = products.find((p) => p.id === sp.id);
        if (product) {
          await axios.put(
            `${Api}product/update.php?id=${sp.id}`,
            { stock: product.stock - sp.quantity },
            { headers: { "Content-Type": "application/json" } }
          );
        }
      }

      alert("Stock credited successfully!");
      fetchProducts();
      fetchCredits();

      setWorkerName("");
      setWorkerPhone("");
      setWorkerAddress("");
      setSelectedProducts([]);
    } catch (err) {
      console.error(err);
    }
  };

  // Save returned quantity per product
  // const handleSaveReturn = async (item, record) => {
  //   if (editValue < 0 || editValue > item.quantity) {
  //     alert("Invalid returned quantity!");
  //     return;
  //   }

  //   const diff = editValue - (item.returned_qty || 0);

  //   try {
  //     // update product stock
  //     const product = products.find((p) => p.id === parseInt(item.product_id));
  //     if (!product) {
  //       alert("Product not found!");
  //       return;
  //     }

  //     await axios.put(
  //       `${Api}product/update.php?id=${product.id}`,
  //       { stock: product.stock + diff },
  //       { headers: { "Content-Type": "application/json" } }
  //     );

  //     // update stockcredit record
  //     const returnedFlag = editValue === item.quantity ? 1 : 0;
  //     await axios.put(
  //       `${Api}stockcredit/stockcredit_return.php?id=${item.id}`,
  //       {
  //         quantity: item.quantity,
  //         returned_qty: editValue,
  //         returned: returnedFlag,
  //       },
  //       { headers: { "Content-Type": "application/json" } }
  //     );

  //     // update local state
  //     setRecords((prev) =>
  //       prev.map((rec) =>
  //         rec.id === record.id
  //           ? {
  //               ...rec,
  //               products: rec.products.map((p) =>
  //                 p.id === item.id
  //                   ? { ...p, returned_qty: editValue, returned: returnedFlag }
  //                   : p
  //               ),
  //             }
  //           : rec
  //       )
  //     );

  //     setEditRecordId(null);
  //     setEditValue(0);
  //     fetchProducts();
  //     alert("Return quantity updated!");
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
  // Save returned quantity per product
  const handleSaveReturn = async (item, record) => {
    if (editValue < 0 || editValue > item.quantity) {
      alert("Invalid returned quantity!");
      return;
    }

    const diff = editValue - (item.returned_qty || 0);

    try {
      // 1️⃣ Update product stock
      const product = products.find((p) => p.id === parseInt(item.product_id));
      if (!product) {
        alert("Product not found!");
        return;
      }

      await axios.put(
        `${Api}product/update.php?id=${product.id}`,
        { stock: product.stock + diff },
        { headers: { "Content-Type": "application/json" } }
      );

      // 2️⃣ Update stock_credit_items table
      await axios.put(
        `${Api}stockcredit/stockcredit_return.php?id=${item.id}`,
        {
          quantity: item.quantity,
          returned_qty: editValue,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      // 3️⃣ Update local state
      setRecords((prev) =>
        prev.map((rec) =>
          rec.id === record.id
            ? {
                ...rec,
                products: rec.products.map((p) =>
                  p.id === item.id
                    ? {
                        ...p,
                        returned_qty: editValue,
                        returned: editValue === p.quantity ? 1 : 0,
                      }
                    : p
                ),
              }
            : rec
        )
      );

      setEditRecordId(null);
      setEditValue(0);
      fetchProducts();
      alert("Return quantity updated!");
    } catch (err) {
      console.error(err);
      alert("Failed to update return quantity.");
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-5xl mx-auto bg-white p-6 rounded shadow">
        <h2 className="text-2xl font-semibold mb-4">Stock Credit</h2>

        {/* Worker Info + Product Form */}
        <form onSubmit={handleSubmit} className="space-y-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Worker Name"
              value={workerName}
              onChange={(e) => setWorkerName(e.target.value)}
              className="border rounded px-3 py-2"
            />
            <input
              type="text"
              placeholder="Worker Phone"
              value={workerPhone}
              onChange={(e) => setWorkerPhone(e.target.value)}
              className="border rounded px-3 py-2"
            />
            <input
              type="text"
              placeholder="Worker Address"
              value={workerAddress}
              onChange={(e) => setWorkerAddress(e.target.value)}
              className="border rounded px-3 py-2"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="border rounded px-3 py-2"
            >
              <option value="">Select Category</option>
              {categories.map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))}
            </select>

            <select
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e.target.value)}
              className="border rounded px-3 py-2"
            >
              <option value="">Select Product</option>
              {products
                .filter((p) => p.category === selectedCategory)
                .map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.product} (Stock: {p.stock})
                  </option>
                ))}
            </select>

            <input
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              className="border rounded px-3 py-2"
            />

            <button
              type="button"
              onClick={handleAddProduct}
              className="bg-green-600 text-white px-4 py-2 rounded"
            >
              Add Product
            </button>
          </div>

          {selectedProducts.length > 0 && (
            <table className="min-w-full border mt-4">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-3 py-1 border">Product</th>
                  <th className="px-3 py-1 border">Category</th>
                  <th className="px-3 py-1 border">Quantity</th>
                </tr>
              </thead>
              <tbody>
                {selectedProducts.map((sp, i) => (
                  <tr key={i}>
                    <td className="px-3 py-1 border">{sp.product}</td>
                    <td className="px-3 py-1 border">{sp.category}</td>
                    <td className="px-3 py-1 border">{sp.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded"
          >
            Submit All
          </button>
        </form>

        {/* Records Table */}
        {/* Records Table */}
        <h3 className="text-xl font-semibold mb-3">Stock Credit Records</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full border">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-3 py-2 border">Credit ID</th>
                <th className="px-3 py-2 border">Worker</th>
                <th className="px-3 py-2 border">Phone</th>
                <th className="px-3 py-2 border">Address</th>
                <th className="px-3 py-2 border">Date</th>
                <th className="px-3 py-2 border">Product</th>
                <th className="px-3 py-2 border">Category</th>
                <th className="px-3 py-2 border">Quantity</th>
                <th className="px-3 py-2 border">Returned Qty</th>
                <th className="px-3 py-2 border">Balance</th>
                <th className="px-3 py-2 border">Action</th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((r, serialIndex) =>
                  r.products.map((item, index) => {
                    const balance = item.quantity - (item.returned_qty || 0);
                    return (
                      <tr key={item.id}>
                        {index === 0 && (
                          <>
                            <td
                              rowSpan={r.products.length}
                              className="px-3 py-2 border text-center"
                            >
                              {serialIndex + 1}{" "}
                              {/* Serial number instead of credit_id */}
                            </td>
                            <td
                              rowSpan={r.products.length}
                              className="px-3 py-2 border"
                            >
                              {r.worker_name}
                            </td>
                            <td
                              rowSpan={r.products.length}
                              className="px-3 py-2 border"
                            >
                              {r.worker_phone}
                            </td>
                            <td
                              rowSpan={r.products.length}
                              className="px-3 py-2 border"
                            >
                              {r.worker_address}
                            </td>
                            <td
                              rowSpan={r.products.length}
                              className="px-3 py-2 border"
                            >
                              {r.created_at}
                            </td>
                          </>
                        )}
                        <td className="px-3 py-2 border">{item.product}</td>
                        <td className="px-3 py-2 border">{item.category}</td>
                        <td className="px-3 py-2 border">{item.quantity}</td>

                        {/* Returned Qty */}
                        <td className="px-3 py-2 border">
                          {editRecordId === item.id ? (
                            <input
                              type="number"
                              min="0"
                              max={item.quantity}
                              value={editValue}
                              onChange={(e) =>
                                setEditValue(Number(e.target.value))
                              }
                              className="w-20 border rounded px-2 py-1"
                            />
                          ) : (
                            item.returned_qty || 0
                          )}
                        </td>

                        {/* Balance */}
                        <td
                          className={`px-3 py-2 border font-semibold ${
                            balance > 0 ? "text-red-600" : "text-green-600"
                          }`}
                        >
                          {balance}
                        </td>

                        {/* Action */}
                        {/* <td className="px-3 py-2 border">
                          {balance === 0 ? (
                            <div className="flex gap-2 items-center">
                              <span className="text-green-600 font-semibold">
                                Returned
                              </span>
                              <button
                                onClick={async () => {
                                  if (
                                    window.confirm(
                                      "Are you sure to delete this product?"
                                    )
                                  ) {
                                    try {
                                      await axios.delete(
                                        `${Api}stockcredit/stockcredit_item_delete.php?id=${item.id}`
                                      );
                                      fetchCredits();
                                      alert("Product deleted successfully!");
                                    } catch (err) {
                                      console.error(err);
                                    }
                                  }
                                }}
                                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                              >
                                Delete
                              </button>
                            </div>
                          ) : editRecordId === item.id ? (
                            <div className="flex gap-2">
                              <button
                                onClick={() => handleSaveReturn(item, r)}
                                className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                              >
                                Save
                              </button>
                              <button
                                onClick={() => {
                                  setEditRecordId(null);
                                  setEditValue(0);
                                }}
                                className="bg-gray-400 text-white px-3 py-1 rounded hover:bg-gray-500"
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                setEditRecordId(item.id);
                                setEditValue(item.returned_qty || 0);
                              }}
                              className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                            >
                              Edit
                            </button>
                          )}
                        </td> */}

                        <td className="px-3 py-2 border">
                          {balance === 0 ? (
                            <div className="flex gap-2 items-center">
                              <span className="text-green-600 font-semibold">
                                Returned
                              </span>
                              <button
                                onClick={async () => {
                                  // SweetAlert2 verification + delete logic here
                                  const confirmResult = await Swal.fire({
                                    title: "Are you sure?",
                                    text: "This will permanently delete this product record.",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#d33",
                                    cancelButtonColor: "#3085d6",
                                    confirmButtonText: "Yes, continue",
                                  });

                                  if (!confirmResult.isConfirmed) return;

                                  const { value: credentials } =
                                    await Swal.fire({
                                      title: "Admin Verification Required",
                                      html: `
              <input type="text" id="swal-username" class="swal2-input" placeholder="Admin Username" />
              <input type="password" id="swal-password" class="swal2-input" placeholder="Admin Password" />
            `,
                                      focusConfirm: false,
                                      showCancelButton: true,
                                      confirmButtonText: "Verify & Delete",
                                      preConfirm: () => {
                                        const username =
                                          document.getElementById(
                                            "swal-username"
                                          ).value;
                                        const password =
                                          document.getElementById(
                                            "swal-password"
                                          ).value;

                                        if (!username || !password) {
                                          Swal.showValidationMessage(
                                            "Please enter both username and password"
                                          );
                                          return false;
                                        }
                                        return { username, password };
                                      },
                                    });

                                  if (!credentials) return;

                                  try {
                                    const verifyRes = await axios.post(
                                      `${Api}admin/login.php`,
                                      {
                                        username: credentials.username,
                                        password: credentials.password,
                                      }
                                    );

                                    if (
                                      !verifyRes.data ||
                                      !verifyRes.data.token
                                    ) {
                                      Swal.fire(
                                        "Error!",
                                        "Invalid admin credentials!",
                                        "error"
                                      );
                                      return;
                                    }

                                    await axios.delete(
                                      `${Api}stockcredit/stockcredit_item_delete.php?id=${item.id}`
                                    );
                                    Swal.fire(
                                      "Deleted!",
                                      "Product deleted successfully.",
                                      "success"
                                    );
                                    fetchCredits();
                                  } catch (err) {
                                    console.error(err);
                                    Swal.fire(
                                      "Error!",
                                      "Failed to verify admin or delete product.",
                                      "error"
                                    );
                                  }
                                }}
                                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                              >
                                Delete
                              </button>
                            </div>
                          ) : editRecordId === item.id ? (
                            // ... (keep your existing Save / Cancel / Edit logic)
                            <div className="flex gap-2">
                              <button
                                onClick={() => handleSaveReturn(item, r)}
                                className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                              >
                                Save
                              </button>
                              <button
                                onClick={() => {
                                  setEditRecordId(null);
                                  setEditValue(0);
                                }}
                                className="bg-gray-400 text-white px-3 py-1 rounded hover:bg-gray-500"
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                setEditRecordId(item.id);
                                setEditValue(item.returned_qty || 0);
                              }}
                              className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                            >
                              Edit
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )
              ) : (
                <tr>
                  <td colSpan="12" className="text-center py-2">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
